/* Project Botanical — theme JS
   Vanilla JS, no framework. Cart drawer, mobile menu, qty, variants. */

(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ----- Mobile menu ----- */
  const mobileToggle = $('[data-mobile-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      const expanded = mobileMenu.classList.contains('is-open');
      mobileToggle.setAttribute('aria-expanded', String(expanded));
    });
  }

  /* ----- Cart drawer ----- */
  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-drawer-overlay]');

  function openDrawer() {
    drawer && drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  $$('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      refreshCartDrawer();
      openDrawer();
    });
  });

  $$('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ----- Quantity steppers ----- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const dir = btn.dataset.qtyBtn;
    const wrap = btn.closest('[data-qty]');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    if (dir === 'inc') val += 1;
    if (dir === 'dec') val = Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Variant picker on product page ----- */
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-variant-input]');
    if (!input) return;
    updateVariant(input.closest('form'));
  });

  function updateVariant(form) {
    if (!form) return;
    const productJson = form.querySelector('[data-product-json]');
    if (!productJson) return;
    let product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

    const selected = $$('[data-variant-input]:checked', form).map(i => i.value);
    const match = product.variants.find(v =>
      v.options.every((opt, idx) => opt === selected[idx])
    );

    if (!match) return;

    const priceEl = form.querySelector('[data-product-price]');
    const compareEl = form.querySelector('[data-product-compare]');
    const idInput = form.querySelector('[name="id"]');
    const submitBtn = form.querySelector('[type="submit"]');
    const galleryMain = form.parentElement && form.parentElement.querySelector('[data-gallery-main] img');

    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (idInput) idInput.value = match.id;
    if (submitBtn) {
      if (match.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.addLabel || 'Add to Cart';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    }
    if (galleryMain && match.featured_image) {
      galleryMain.src = match.featured_image;
    }
  }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return `$${value}`;
  }

  /* ----- Add to cart (Ajax) ----- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await refreshCart();
      openDrawer();
    } catch (err) {
      console.error(err);
      alert('Could not add to cart. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel || 'Add to Cart';
      }
    }
  });

  /* ----- Cart count + drawer refresh ----- */
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      const counts = $$('[data-cart-count]');
      counts.forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
      await refreshCartDrawer();
    } catch (e) { console.error(e); }
  }

  async function refreshCartDrawer() {
    const drawerBody = $('[data-cart-drawer-body]');
    if (!drawerBody) return;
    try {
      const res = await fetch('/?section_id=cart-drawer');
      if (!res.ok) return;
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newBody = tmp.querySelector('[data-cart-drawer-inner]');
      if (newBody) drawerBody.innerHTML = newBody.innerHTML;
    } catch (e) { console.error(e); }
  }

  /* ----- Cart line item updates (qty change / remove) ----- */
  document.addEventListener('change', async e => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    const key = input.dataset.cartQty;
    const qty = parseInt(input.value, 10) || 0;
    await updateLine(key, qty);
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.cartRemove;
    await updateLine(key, 0);
  });

  async function updateLine(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('Cart update failed');
      // Reload page if on cart page, else just refresh cart
      if (location.pathname.includes('/cart')) {
        location.reload();
      } else {
        await refreshCart();
      }
    } catch (e) { console.error(e); }
  }

  /* ----- Product gallery thumbs ----- */
  document.addEventListener('click', e => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const main = $('[data-gallery-main] img');
    const src = thumb.dataset.fullsrc || thumb.querySelector('img').src;
    if (main) main.src = src;
    $$('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });

  /* ----- Library alphabet filter ----- */
  $$('[data-alpha-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const letter = btn.dataset.alphaBtn.toLowerCase();
      $$('[data-alpha-btn]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      $$('[data-herb-card]').forEach(card => {
        const name = (card.dataset.name || '').toLowerCase();
        const show = letter === 'all' || name.startsWith(letter);
        card.style.display = show ? '' : 'none';
      });
    });
  });

  /* ----- Library search ----- */
  const librarySearch = $('[data-library-search]');
  if (librarySearch) {
    librarySearch.addEventListener('input', e => {
      const q = e.target.value.toLowerCase().trim();
      $$('[data-herb-card]').forEach(card => {
        const text = card.textContent.toLowerCase();
        card.style.display = text.includes(q) ? '' : 'none';
      });
    });
  }

  /* ----- Lazy fade-in on intersection ----- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('pb-fade-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('[data-fade]').forEach(el => io.observe(el));
  }

  /* Init */
  document.addEventListener('DOMContentLoaded', () => {
    refreshCart().catch(() => {});
  });
})();
